import * as Yup from 'yup'

export function ValidateForm(values) {
    return Yup.object().shape({
        name: Yup.string().required('This field is required'),
        status: Yup.string().required('This field is required')
    });
}
